import {Platform} from 'react-native';
import {getWidthHeight} from '../services/utility';
const width = getWidthHeight()[0];
const vars = {
  RIGHT_MENU_WIDTH: width > 1500 ? 250 : 200,
  LEFT_SECTION_WIDTH:
    width > 1500 ? 'calc(100% - 250px)' : 'calc(100% - 200px)',
  BASKET_WIDTH_WITH_OPEN_MENU:
    width > 1500 ? 'calc(100% - 290px)' : 'calc(100% - 240px)',
  BASKET_WIDTH_WITH_CLOSE_MENU: 'calc(100% - 40px)',
  HalfVert: width > 440 ? 'calc(50% - 50px)' : 'calc(50% - 20px)',
  NAV_BAR_H: '55px',
  YELLOW: '#FFAA00',
  CREAM: '#FFAA0045',
  DARK_CREAM: '#FFAA0085',
  SOLID_CREAM: '#FFEFCE',
  ORANGE: '#FFAA00',
  YELLOW_WHITE: '#FFEFCE',
  ORANGE_RED: '#FF6600',
  WHITE: '#FFFFFF',
  transparent: '#FFFFFF00',
  darkTransparent: 'rgba(230,230,230,0.8)',
  BLACK: '#000000',
  DARK_WHITE: '#EEEEEE',
  DARK_BLUE: '#013243',
  SILVER: '#E6E6E6',
  LIGHT_SILVER: '#707070',
  DARK_SILVER: '#5B5B5B',
  RED: '#FF0000',
  GREEN: '#307E42',
  ORANGE_LIGHT: '#FFAA0073',
  alignSelf: Platform.OS === 'web' ? 'flex-start' : 'flex-end',
  alignSelfRev: Platform.OS === 'web' ? 'flex-end' : 'flex-start',
  flexDirection: Platform.OS === 'web' ? 'row' : 'row-reverse',
  flexDirectionRev: Platform.OS === 'web' ? 'row-reverse' : 'row',

  DARK_THEME_LEVEL2: '#262d79',

  COLOR_BASE_100: '#09002f',
  COLOR_BASE_200: '#120b3d',
  COLOR_BASE_300: '#1c184b',
  COLOR_BASE_500: '#342c86',
  COLOR_BASE_CONTENT: '#a1b1ff',
  COLOR_PRIMARY: '#f861b4',
  COLOR_PRIMARY_CONTENT: '#500323',
  COLOR_SECONDARY: '#71d1fe',
  COLOR_SECONDARY_CONTENT: '#042e49',
  COLOR_ACCENT: '#ff8904',
  COLOR_ACCENT_CONTENT: '#421104',
  COLOR_NEUTRAL: '#422AD5',
  COLOR_NEUTRAL_CONTENT: '#c6d2ff',
  COLOR_NEUTRAL_HOVER: '#2c1b90',
  COLOR_INFO: '#00bafe',
  COLOR_INFO_CONTENT: '#042e49',
  COLOR_SUCCESS: '#00d3bb',
  COLOR_SUCCESS_CONTENT: '#002d2c',
  COLOR_WARNING: '#fede1c',
  COLOR_WARNING_CONTENT: '#733e0a',
  COLOR_ERROR: '#ec8c78',
  COLOR_ERROR_CONTENT: '#201047',
  COLOR_ALERT: '#fff0ef',
  COLOR_ALERT_CONTENT: '#ff5861',
  GRADIENT: 'linear-gradient(to left, #342c86, #09002f)',

  LIGHT_COLOR_BASE_100: '#ffffff',
  LIGHT_COLOR_BASE_200: '#e8e8e8',
  LIGHT_COLOR_BASE_300: '#d1d1d1',
  LIGHT_COLOR_BASE_500: '#ff8600',
  LIGHT_COLOR_BASE_CONTENT: '#1f2937',
  LIGHT_COLOR_PRIMARY: '#6d0076',
  LIGHT_COLOR_PRIMARY_CONTENT: '#e3cee4',
  LIGHT_COLOR_SECONDARY: '#0075c2',
  LIGHT_COLOR_SECONDARY_CONTENT: '#cfe4f4',
  LIGHT_COLOR_ACCENT: '#ff8600',
  LIGHT_COLOR_ACCENT_CONTENT: '#180600',
  LIGHT_COLOR_NEUTRAL: '#1f2937',
  LIGHT_COLOR_NEUTRAL_CONTENT: '#cdd0d3',
  LIGHT_COLOR_NEUTRAL_HOVER: '#00b5ff',
  LIGHT_COLOR_INFO: '#000000',
  LIGHT_COLOR_INFO_CONTENT: '#042e49',
  LIGHT_COLOR_SUCCESS: '#00a96e',
  LIGHT_COLOR_SUCCESS_CONTENT: '#000000',
  LIGHT_COLOR_WARNING: '#ffbe00',
  LIGHT_COLOR_WARNING_CONTENT: '#000000',
  LIGHT_COLOR_ERROR: '#ff5861',
  LIGHT_COLOR_ERROR_CONTENT: '#000000',
  LIGHT_COLOR_ALERT: '#fff0ef',
  LIGHT_COLOR_ALERT_CONTENT: '#ff5861',
  LIGHT_GRADIENT: 'linear-gradient(to left, #FFAA00, #FF6600)',

  // LIGHT_THEME COLORS
  LIGHT_THEME_COLOR_1: '#FFAA00',
  LIGHT_THEME_COLOR_2: '#201a47',
  LIGHT_THEME_COLOR_3: '#332971',
  LIGHT_THEME_COLOR_4: '#46399c',
  LIGHT_THEME_COLOR_5: '#5948c6',
  LIGHT_THEME_COLOR_6: '#6c58f1',

  // DARK_THEME COLORS
  DARK_THEME_COLOR_1: '#7fc194',
  DARK_THEME_COLOR_2: '#201a47',
  DARK_THEME_COLOR_3: '#332971',
  DARK_THEME_COLOR_4: '#46399c',
  DARK_THEME_COLOR_5: '#5948c6',
  DARK_THEME_COLOR_6: '#6c58f1',
};
export default vars;
